import { Helmet } from "react-helmet-async";

const SITE_URL = "https://khaledkasmou.me";
const DEFAULT_OG = `${SITE_URL}/og-image.jpg`;

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  image?: string;
  type?: "website" | "article" | "profile";
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noindex?: boolean;
}

/**
 * Per-route SEO/AEO/GEO meta. Sets <title>, description, canonical,
 * OG/Twitter tags, optional JSON-LD structured data.
 */
export const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  jsonLd,
  noindex = false,
}: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Khaled Kasmou" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* GEO signals */}
      <meta name="geo.region" content="BG-23" />
      <meta name="geo.placename" content="Sofia" />
      <meta name="geo.position" content="42.6977;23.3219" />
      <meta name="ICBM" content="42.6977, 23.3219" />

      {jsonLdArray.map((item, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};
